import { render, staticRenderFns } from "./Yoke.vue?vue&type=template&id=60024034&scoped=true&"
import script from "./Yoke.vue?vue&type=script&lang=js&"
export * from "./Yoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60024034",
  null
  
)

export default component.exports